import {
	AppBar,
	Button,
	CircularProgress,
	createTheme,
	Dialog,
	DialogContent,
	FormControl,
	IconButton,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	Slide,
	TextField,
	Toolbar,
	Typography,
	useMediaQuery,
} from "@mui/material"
import { forwardRef, useContext, useEffect, useState } from "react"
import { AdminContext } from "../views/Admin"
import CloseIcon from "@mui/icons-material/Close"
import { extUpdatePostV2, getPostDataForEditV2 } from "../util/firebase"
import { dateToFirebaseTimestamp, firebaseTimeStampToDate } from "../util/helpers"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs from "dayjs"
import "dayjs/locale/he"

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />
})

const mdTheme = createTheme({
	palette: {
		primary: {
			main: "#132242",
		},
		secondary: {
			main: "#DF0A0A",
		},
		white: {
			main: "white",
		},
	},
})

const EditGovIlData = () => {
	const adminContext = useContext(AdminContext)
	const editGovIlDataOpen = adminContext.editGovIlDataOpen
	const setEditGovIlDataOpen = adminContext.setEditGovIlDataOpen
	const handleOpenSnackbar = adminContext.handleOpenSnackbar
    const refreshPost = adminContext.refreshPost

	const post = adminContext.post

	const matches = useMediaQuery(mdTheme.breakpoints.up("md"))

    const [postStatus, setPostStatus] = useState("")

	const [make, setMake] = useState("")
	const [model, setModel] = useState("")
	const [year, setYear] = useState("")
	const [trimLevel, setTrimLevel] = useState("")
	const [lastRegistrationDate, setLastRegistrationDate] = useState(null)
	const [registrationExpiryDate, setRegistrationExpiryDate] = useState(null)
	const [ownership, setOwnership] = useState("")
	const [vin, setVin] = useState("")
	const [color, setColor] = useState("")
	const [frontWheelSize, setFrontWheelSize] = useState("")
	const [rearWheelSize, setRearWheelSize] = useState("")
	const [firstRegistration, setFirstRegistration] = useState(null)
	const [engineVolume, setEngineVolumne] = useState("")
	const [driveTrain, setDriveTrain] = useState("")
	const [noOfAirBags, setNoOfAirBags] = useState("")
	const [transMission, setTransMission] = useState("")
	const [noOfPowerWindows, setNoOfPowerWindows] = useState("")
	const [bodyType, setBodyType] = useState("")
	const [noOfDoors, setNoOfDoors] = useState("")
	const [horsePower, setHorsePower] = useState("")
	const [noOfSeats, setNoOfSeats] = useState("")
	const [powerTrain, setPowerTrain] = useState("")
	const [pollutionLevel, setPollutionLevel] = useState("")
	const [safteyScore, setSafetyScore] = useState("")
	const [fuelType, setFuelType] = useState("")

	const [loading, setLoading] = useState(false)
	/* const [noFilters, setNoFilters] = useState(true) */

	const handleSaveGovIlData = async () => {
		try {
			let yearInt
			let lastRegistrationDateTimeStamp
			let registrationExpiryDateTimeStamp
			let firstRegistrationTimeStamp
			if (year) yearInt = parseInt(year)
			if (lastRegistrationDate) lastRegistrationDateTimeStamp = dateToFirebaseTimestamp(lastRegistrationDate.toDate())
			if (registrationExpiryDate)
				registrationExpiryDateTimeStamp = dateToFirebaseTimestamp(registrationExpiryDate.toDate())
			if (firstRegistration) firstRegistrationTimeStamp = dateToFirebaseTimestamp(firstRegistration.toDate())
			const updatedGovIlData = {
				make,
				model,
				year: yearInt,
				trimLevel,
				lastRegistrationDate: lastRegistrationDateTimeStamp,
				registrationExpiryDate: registrationExpiryDateTimeStamp,
				ownership,
				vin,
				color,
				frontWheelSize,
				rearWheelSize,
				firstRegistration: firstRegistrationTimeStamp,
				engineVolume,
				driveTrain,
				noOfAirBags,
				transMission,
				noOfPowerWindows,
				bodyType,
				noOfDoors,
				horsePower,
				noOfSeats,
				powerTrain,
				pollutionLevel,
				safteyScore,
				fuelType,
			}
			console.log(updatedGovIlData)
			const response = await extUpdatePostV2({ id: post.id, ...updatedGovIlData })
			if (response?.data?.status === 0) {
				await refreshPost(post.id, postStatus)
				handleOpenSnackbar("נתוני משרד הרישוי עודכנו בהצלחה", "success")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון נתוני משרד הרישוי", "error")
		}
		setEditGovIlDataOpen(false)
	}

	useEffect(() => {
		const _getPostDataForEdit = async () => {
			try {
				setLoading(true)
				const response = await getPostDataForEditV2({ id: post.id })
				setLoading(false)
				if (response.data.status === 0) {
                    setPostStatus(response.data.data.status)
					setMake(response.data.data.make ?? "")
					setModel(response.data.data.model ?? "")
					setYear(response.data.data.year ? response.data.data.year.toString() : "")
					setTrimLevel(response.data.data.trimLevel ?? "")
					setLastRegistrationDate(
						response.data.data.lastRegistrationDate
							? dayjs(firebaseTimeStampToDate(response.data.data.lastRegistrationDate))
							: null
					)
					setRegistrationExpiryDate(
						response.data.data.registrationExpiryDate
							? dayjs(firebaseTimeStampToDate(response.data.data.registrationExpiryDate))
							: null
					)
					setOwnership(response.data.data.ownership ?? "")
					setVin(response.data.data.vin ?? "")
					setColor(response.data.data.color ?? "")
					setFrontWheelSize(response.data.data.frontWheelSize ?? "")
					setRearWheelSize(response.data.data.rearWheelSize ?? "")
					setFirstRegistration(
						response.data.data.firstRegistration
							? dayjs(firebaseTimeStampToDate(response.data.data.firstRegistration))
							: null
					)
					setEngineVolumne(response.data.data.engineVolume ?? "")
					setDriveTrain(response.data.data.driveTrain ?? "")
					setNoOfAirBags(response.data.data.noOfAirBags ?? "")
					setTransMission(response.data.data.transMission)
					setNoOfPowerWindows(response.data.data.noOfPowerWindows ?? "")
					setBodyType(response.data.data.bodyType ?? "")
					setNoOfDoors(response.data.data.noOfDoors ?? "")
					setHorsePower(response.data.data.horsePower ?? "")
					setNoOfSeats(response.data.data.noOfSeats ?? "")
					setPowerTrain(response.data.data.powerTrain ?? "")
					setPollutionLevel(response.data.data.pollutionLevel ?? "")
					setSafetyScore(response.data.data.safteyScore ?? "")
					setFuelType(response.data.data.fuelType ?? "")
				}
			} catch (e) {
				console.log(e.message)
				setLoading(false)
			}
		}

		if (post?.id && editGovIlDataOpen) _getPostDataForEdit()
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [editGovIlDataOpen])

	return (
		<Dialog
			fullScreen={!matches}
			open={editGovIlDataOpen}
			onClose={() => setEditGovIlDataOpen(false)}
			TransitionComponent={Transition}
			PaperProps={{
				style: {
					backgroundColor: "white",
					maxHeight: "715px",
				},
			}}
			maxWidth={"md"}
			/* scroll="body" */
			/* sx={{ maxHeight: "715px"}} */
		>
			<AppBar sx={{ position: "relative" }}>
				<Toolbar>
					<IconButton edge="start" color="inherit" onClick={() => setEditGovIlDataOpen(false)} aria-label="close">
						<CloseIcon />
					</IconButton>
					<Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
						עריכת נתוני משרד הרישוי
					</Typography>
				</Toolbar>
			</AppBar>
			<DialogContent dividers>
				<Paper
					sx={{
						p: 2,
						display: "flex",
						flexDirection: matches ? "row" : "column",
						justifyContent: loading ? "center" : "flex-start",
						flexWrap: "wrap",
					}}
				>
					{loading && <CircularProgress color="primary" />}
					{!loading && (
						<>
							<TextField
								label={"יצרן"}
								value={make}
								onChange={(e) => setMake(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"דגם"}
								value={model}
								onChange={(e) => setModel(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"שנת ייצור"}
								value={year}
								onChange={(e) => setYear(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"רמת גימור"}
								value={trimLevel}
								onChange={(e) => setTrimLevel(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"he"}>
								<DatePicker
									label="תאריך טסט אחרון"
									value={dayjs(lastRegistrationDate)}
									onChange={(newValue) => setLastRegistrationDate(newValue)}
									sx={{ m: 2, ".MuiInputBase-input": { p: "8.5px 14px" }, minWidth: "160px" }}
								/>
							</LocalizationProvider>
							<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"he"}>
								<DatePicker
									label="תוקף רישיון"
									value={dayjs(registrationExpiryDate)}
									onChange={(newValue) => setRegistrationExpiryDate(newValue)}
									sx={{ m: 2, ".MuiInputBase-input": { p: "8.5px 14px" }, minWidth: "160px" }}
								/>
							</LocalizationProvider>
							<TextField
								label={"בעלות"}
								value={ownership}
								onChange={(e) => setOwnership(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"מס׳ שלדה"}
								value={vin}
								onChange={(e) => setVin(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "220px" }}
							/>
							<TextField
								label={"צבע"}
								value={color}
								onChange={(e) => setColor(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"צמיג קדמי"}
								value={frontWheelSize}
								onChange={(e) => setFrontWheelSize(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"צמיג אחורי"}
								value={rearWheelSize}
								onChange={(e) => setRearWheelSize(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"he"}>
								<DatePicker
									label={"תאריך עליה לכביש"}
									value={dayjs(firstRegistration)}
									onChange={(newValue) => setFirstRegistration(newValue)}
									sx={{ m: 2, ".MuiInputBase-input": { p: "8.5px 14px" }, minWidth: "160px" }}
								/>
							</LocalizationProvider>
							<TextField
								label={"נפח מנוע"}
								value={engineVolume}
								onChange={(e) => setEngineVolumne(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"הנעה"}
								value={driveTrain}
								onChange={(e) => setDriveTrain(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"מס׳ כריות אוויר"}
								value={noOfAirBags}
								onChange={(e) => setNoOfAirBags(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<FormControl sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} size="small">
								<InputLabel>הילוכים</InputLabel>
								<Select
									/* sx={{ m: 2, maxHeight: "36px", minWidth: "150px" }} */
									size="small"
									value={transMission}
									label="הילוכים"
									onChange={(e) => setTransMission(e.target.value)}
								>
									{[
										{ key: 0, value: "ידני" },
										{ key: 1, value: "אוטומט" },
									].map((key) => (
										<MenuItem key={key.key} value={key.key}>
											{key.value}
										</MenuItem>
									))}
								</Select>
							</FormControl>
							<TextField
								label={"מס׳ חלונות חשמל"}
								value={noOfPowerWindows}
								onChange={(e) => setNoOfPowerWindows(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"מרכב"}
								value={bodyType}
								onChange={(e) => setBodyType(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"מס׳ דלתות"}
								value={noOfDoors}
								onChange={(e) => setNoOfDoors(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"כוח סוס"}
								value={horsePower}
								onChange={(e) => setHorsePower(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"מס׳ מושבים"}
								value={noOfSeats}
								onChange={(e) => setNoOfSeats(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"סוג הנעה"}
								value={powerTrain}
								onChange={(e) => setPowerTrain(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"רמת זיהום אוויר"}
								value={pollutionLevel}
								onChange={(e) => setPollutionLevel(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"דירוג בטיחות"}
								value={safteyScore}
								onChange={(e) => setSafetyScore(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
							<TextField
								label={"סוג דלק"}
								value={fuelType}
								onChange={(e) => setFuelType(e.target.value)}
								size="small"
								sx={{ m: 2, maxHeight: "36px", minWidth: "160px" }}
							/>
						</>
					)}
				</Paper>
				<div style={{ display: "flex", width: "100%", justifyContent: "center", marginBottom: "20px" }}>
					<Button
						sx={{
							m: 2,
							width: matches ? "120px" : "auto",
							backgroundColor: mdTheme.palette.secondary.main,
							"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
						}}
						variant="contained"
						onClick={handleSaveGovIlData}
					>
						שמירה
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	)
}

export default EditGovIlData
